import { render } from "./ChildrenDetailView.vue?vue&type=template&id=569d364d&scoped=true&ts=true"
import script from "./ChildrenDetailView.vue?vue&type=script&lang=ts"
export * from "./ChildrenDetailView.vue?vue&type=script&lang=ts"

import "./ChildrenDetailView.vue?vue&type=style&index=0&id=569d364d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569d364d"]])

export default __exports__